export default "__VITE_ASSET__ILPa1qkw__"